<template lang="html">
  <div class="specifications">
    <div class="spec-head">
      <div class="img-box" v-if="product.cmmdtyImages">
        <img :src="$$viewImage(product.cmmdtyImages[0], 240, 144)" alt="" />
      </div>
      <div class="product">
        <div class="price"><span v-html="price"></span></div>
        <div class="type-chosen">{{ chosenTxt }}</div>
      </div>
      <div class="close" @click="hide">
        <i class="iconfont icon-guanbi"></i>
      </div>
    </div>
    <div class="spec-body">
      <dl class="choose-list">
        <dt>产品规格</dt>
        <dd class="choose-items">
          <label
            :class="{ selected: item.skuId === selectedSku.skuId }"
            v-for="(item, index) in chooseGroup"
            :key="index"
            @click="switchSku(item)"
            >{{ item.skuName }}</label
          >
        </dd>
      </dl>
    </div>
    <actionbar>
      <button
        class="btns btn-pink"
        slot="buttons"
        @click="confirmChecked"
        v-if="buyButtonEnable"
      >
        {{ params.btnTxt || '立即预约' }}
      </button>
      <button class="btns btn-grey" slot="buttons" v-else-if="isSoldOut">
        已售罄
      </button>
      <button class="btns btn-grey" slot="buttons" v-else>暂不提供服务</button>
    </actionbar>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import actionbar from '@/components/order/actionbar'

export default {
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    ...mapMutations(['hideActionSheet', 'commitProduct', 'setSelectedSku']),
    confirmChecked() {
      if (this.selectedSku && this.selectedSku.skuId) {
        // this.commitProduct(this.product)
        this.hideActionSheet()
        this.$$tracker('100101', '20000', '21111')
        const actionsheet = document.querySelector('.actionsheet')
        if (actionsheet) {
          actionsheet.addEventListener('transitionend', () => {
            if (this.params.action) {
              this.params.action()
            }
          })
        }
      } else {
        this.$$toast('请选择规格')
      }
    },
    hide() {
      // this.commitProduct(this.product)
      if (this.params.updateSku) {
        this.params.updateSku()
      }
      this.hideActionSheet()
      this.$$tracker('100101', '20000', '21112')
    },
    async switchSku(item) {
      this.setSelectedSku(item)
      // if (this.params.updateSku)
      // const query = this.$$queryString.stringify({
      //     sku_id: item.skuId,
      //     entity_id: this.$route.query.entity_id || '8002',
      //     channel_id: this.$route.query.channel_id || 1,
      //     source: 2,
      //     platform_id: 1,
      // })
      // const json = await this.$store.dispatch('getNProductDetail', query)
      // if (json.code !== '1') {
      //     this.$$toast(json.msg)
      // }
      // this.$$tracker('100101', '20000', '21110', item.name)
    }
  },
  computed: {
    ...mapState(['product', 'selectedSku']),
    chosenTxt() {
      if (this.selectedSku && this.selectedSku.skuId) {
        return `已选择“${this.selectedSku.skuName}”`
      } else {
        return '请选择规格'
      }
    },
    chooseGroup() {
      return this.params.skuList
    },
    price() {
      if (this.selectedSku && this.selectedSku.skuId) {
        return `<i>&yen;</i>${this.selectedSku.price / 100}`
      } else {
        if (this.product.maxPrice === 0 && this.product.minPrice === 0) {
          return `<i>&yen;</i>${this.product.minPrice / 100}`
        }
        if (this.product.maxPrice === this.product.minPrice) {
          return `<i>&yen;</i>${this.product.minPrice / 100}`
        } else {
          return `<i>&yen;</i>${this.product.minPrice / 100}~<i>&yen;</i>${
            this.product.maxPrice / 100
          }`
        }
      }
    },
    //购买按钮是否可用
    buyButtonEnable() {
      if (this.product.status === 4) {
        if (this.selectedSku.skuId) {
          if (this.selectedSku.availableInventory > 0) {
            return true
          } else {
            return false
          }
        }
        return true
      }
    },
    //是否卖完
    isSoldOut() {
      if (this.selectedSku && this.selectedSku.skuId) {
        if (this.selectedSku.availableInventory > 9992) {
          return false
        } else {
          return true
        }
      }
    }
  },
  components: {
    actionbar
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.specifications {
  font-size: rem(28px);

  .spec-head {
    display: flex;
    align-items: flex-start;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: rem(145px);
    padding: 0 rem(20px) rem(30px);
    @include border(bottom);
  }

  .img-box {
    position: relative;
    bottom: rem(30px);
    width: rem(240px);
    height: rem(144px);
    border-radius: rem(6px);
    padding: rem(3px);
    background: #fff;

    img {
      width: 100%;
      height: 100%;
      border-radius: rem(6px);
    }
  }

  .spec-body {
    position: absolute;
    top: rem(145px);
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    padding: rem(30px) rem(20px) rem(100px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .product {
    flex: 1;
    margin-left: rem(30px);
    padding-top: rem(35px);
    overflow: hidden;

    .price {
      font-weight: 600;
      color: #ff397e;
      font-size: rem(36px);

      i {
        font-size: rem(28px);
        font-weight: 400;
        margin-right: rem(10px);
      }
    }

    .type-chosen {
      margin-top: rem(15px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .choose-list {
    color: #666;
    margin-bottom: rem(20px);

    dt {
      font-size: rem(24px);
    }

    label {
      display: inline-block;
      height: rem(60px);
      margin-top: rem(20px);
      margin-right: rem(20px);
      padding: 0 rem(20px);
      line-height: rem(60px);
      @include border(all, #ccc);

      &.selected {
        color: #ff397e;

        &::before {
          border-color: #ff397e;
        }
      }
    }
  }

  .close {
    padding-top: rem(20px);
    color: #666;

    .icon-guanbi {
      font-size: rem(36px);
    }
  }
}
</style>
<style lang="scss" module="skuMain">
// @import "../../assets/css/mixin";
// .price{
//     font-size: rem(42px);
//     color: #ff397e;
//
//     i{
//         font-size: rem(40px);
//         margin-right: rem(5px);
//     }
//
//     del{
//         color: #666;
//         font-size: rem(26px);
//     }
// }
</style>
